<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import OfflineBanner from '@/components/OfflineBanner.vue'

const { toasts } = useToast()
</script>

<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed inset-x-4 top-[max(1rem,env(safe-area-inset-top))] z-50 mx-auto flex max-w-[420px] flex-col items-center gap-2"
    >
      <OfflineBanner />
      <div
        v-for="toast in toasts"
        :key="toast.id"
        role="status"
        aria-live="polite"
        class="pointer-events-auto rounded-full bg-inverse-surface px-4 py-2 font-sans text-[13px] font-medium text-inverse-on-surface shadow-lg"
      >
        {{ toast.message }}
      </div>
    </div>
  </Teleport>
</template>
